























/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */
import { EEntities } from '@/types'
import {
  IPersonBase,
  IPriorityLevelForSelection,
  IStatusForSelection,
} from '@/api/types/response.types'
import { IJobInfo } from '@/types/data-objects/items'

/* API */

export default Vue.extend({
  name: 'ItemDetailPickerOptions',

  props: {
    assigneeId: {
      type: Number,
      default: null,
    },
    priorityId: {
      type: Number,
      default: null,
    },
    statusId: {
      type: Number,
      default: null,
    },
    dueDate: {
      type: [Date, String],
      default: null,
    },
    assigneeOptions: {
      type: Array as () => IPersonBase[],
      required: true,
    },
    statusOptions: {
      type: Array as () => IStatusForSelection[],
      required: true,
    },
    priorityOptions: {
      type: Array as () => IPriorityLevelForSelection[],
      required: true,
    },
    jobInfo: {
      type: Object as () => IJobInfo,
      default: null,
    },
  },

  data() {
    return {
      EEntities,
    }
  },
  computed: {
    internalAssigneeID: {
      get(): any {
        return this.assigneeId
      },
      set(newValue: any) {
        this.$emit('update:assigneeId', newValue)
      },
    },
    internalPriorityID: {
      get(): any {
        return this.priorityId
      },
      set(newValue: any) {
        this.$emit('update:priorityId', newValue)
      },
    },
    internalStatusID: {
      get(): any {
        return this.statusId
      },
      set(newValue: any) {
        this.$emit('update:statusId', newValue)
      },
    },
    internalDueDate: {
      get(): any {
        return this.dueDate
      },
      set(newValue: any) {
        this.$emit('update:dueDate', newValue)
      },
    },
    hasJobs(): boolean {
      return this.jobInfo !== null
    },
  },
})
